module.exports = __webpack_public_path__ + "static/media/Tw-Cen-MT.2e76b7be.svg";